import React from "react";
import { Link } from "react-router-dom";

const AboutOne = () => {
  return (
    <div className="about-area-1 position-relative space-top">
      <div className="about1-shape-img1">
        <img
          className="about1-shape-img-1"
          src="assets/img/sobrenos/1.png"
          alt="Imagem Corporativa Grupo Rocvel"
        />
      </div>
      <div className="about1-shape-img2">
        <img
          className="about1-shape-img-2"
          src="assets/img/normal/about_shape1-2.png"
          alt="Detalhe Visual Rocvel"
        />
      </div>
      <div className="container">
        <div className="row gx-60 align-items-center">
          <div className="col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area me-xl-5 mb-20">
                <span className="sub-title">
                  <img src="assets/img/icon/title_left.svg" alt="Ícone Nossas Diretrizes Rocvel" />
                  Nossas Diretrizes
                </span>
                <h2 className="sec-title">Alinhamento Estratégico </h2>
                <p className="sec-text mb-35">
                  Nossos valores fundamentam cada etapa do processo seletivo, garantindo conexões de valor entre empresas e profissionais através de uma atuação ética, transparente e focada em resultados reais.
                </p>
              </div>
              
              {/* Card 1 */}
              <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Missão Orientada à Performance</h3>
                    <p className="achive-about_text">
                      Desenvolver soluções em recrutamento e gestão de talentos, promovendo conexões de valor entre empresas e profissionais por meio de processos modernos e humanizados.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Visão de Excelência Nacional</h3>
                    <p className="achive-about_text">
                      Ser reconhecida em todo o território nacional como uma marca de excelência em soluções corporativas de RH, elevando o padrão estratégico através da inovação e credibilidade.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;